import { ReactNode } from "react"
import { Head, usePage } from "@inertiajs/react"
import type { PageProps } from "@/types/models"

interface Props {
  children: ReactNode
  title?: string
}

export function AppLayout({ children, title }: Props) {
  const { flash } = usePage<PageProps>().props

  return (
    <div className="bg-slate-50 text-slate-900 antialiased min-h-screen">
      {title && <Head title={title} />}
      <main className="mx-auto flex max-w-4xl flex-col gap-8 px-4 pb-16 pt-12 sm:px-6">
        {Object.entries(flash).map(([type, message]) => {
          if (!message) return null

          const css =
            type === "notice"
              ? "border-emerald-200 bg-emerald-50 text-emerald-900"
              : "border-rose-200 bg-rose-50 text-rose-900"

          return (
            <div
              key={type}
              className={`rounded-md border px-4 py-3 text-sm font-medium ${css}`}
            >
              {message}
            </div>
          )
        })}

        {children}
      </main>
    </div>
  )
}
